interface ConnectionOwnerNoticeProps {
  isOwner: boolean;
  connectedBy: string | null;
  connectedByName: string;
}

/**
 * Muted helper text shown under an integration's toggle/edit controls when
 * the viewer is not the person who connected it. Renders nothing when there
 * is no owner yet (connectedBy is null) or when the viewer is the owner.
 */
export function ConnectionOwnerNotice({
  isOwner,
  connectedBy,
  connectedByName,
}: ConnectionOwnerNoticeProps) {
  if (isOwner || !connectedBy) return null;

  return (
    <p className="mt-2 text-xs text-muted-foreground">
      Connected by {connectedByName}. Only they can change this connection.
    </p>
  );
}
